export default __webpack_public_path__ + "static/media/file-upload.cdcd72ad.png";